
export const enum UserPlotsActionType {
  UpdateEligiblePlots = 'userPlots/updateEligiblePlots',
  UpdatePlotIds = 'userPlots/updatePlotIds',
  Clear = 'userPlots/clear',
  UpdateEligiblePlotsState = 'userPlots/updateEligiblePlotsState',
  UpdatePlotIdsState = 'userPlots/updatePlotsIdsState',
}
